import Divider, { DividerPropsVariantOverrides } from "@mui/material/Divider";
import { OverridableStringUnion } from "@mui/types";
const ApCustomDivider = ({
  orientation = undefined,
  variant = undefined,
  sx = {},
  className,
}: {
  orientation?: "vertical" | "horizontal" | undefined;
  variant?:
    | OverridableStringUnion<
        "inset" | "fullWidth" | "middle",
        DividerPropsVariantOverrides
      >
    | undefined;
  sx?: any;
  className?: any;
}) => {
  return (
    <Divider
      orientation={orientation}
      variant={variant}
      sx={sx}
      className={className ?? ""}
    />
  );
};
export default ApCustomDivider;
